import CheckinsList from './CheckinsList.component';

export default CheckinsList;
